import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import COMPONENT_LIST_SET  from '../queries/COMPONENT_LIST_SET';

const useComponentListSet = () => {
    const [ fetchCLSet, { data, loading, error } ] = useLazyQuery( COMPONENT_LIST_SET );

    const clsDataSet = useMemo( () => {
        if ( data?.componentListSet ) {
            return { ...data.componentListSet.node, key: data.componentListSet.node.componentListSetId };
        } else {
            return [];
        }
    }, [ data ] );
    
    const loadCLSet = ( id ) => {
        const vars = {
            variables: {
                componentListSetId: id
            },
            fetchPolicy: 'network-only' 
        };

        return fetchCLSet( vars );
    };

    return useMemo( () => {
        return {
            loadCLSet,
            clsDataSet,
            clsError: error,
            clsLoading: loading
        };
    }, [ loadCLSet, clsDataSet, error, loading ] );
};

export default useComponentListSet;
